import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { routes } from './auth.routes';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { Oauth2CallbackComponent } from './components/oauth2-callback/oauth2-callback.component';

@NgModule({
  declarations: [
    LoginComponent,
    LogoutComponent,
    Oauth2CallbackComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  providers: [
    // Removed APP_INITIALIZER - no longer needed
  ],
})
export class AuthModule { }
